// extracted by mini-css-extract-plugin
export default {"back":"ButtonBack_back__TKIaw","backRight":"ButtonBack_backRight__ETDnp","mobileBackButton":"ButtonBack_mobileBackButton__BuL47","down":"ButtonBack_down__9rDqb"};